import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=d00947ca"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1465996501/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d00947ca')) {
      api.createRecord('d00947ca', component.options)
    } else {
      api.reload('d00947ca', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=d00947ca", function () {
      api.rerender('d00947ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/upload.vue"
export default component.exports